import { usePut } from '../../HttpClient';
import { brandBaseUrl } from '../BaseUrls';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';
import { Brand } from '../../../models/Tms';

export function useUpdateBrand() {
  const put = usePut(true, "tms");
  const updateBrand = (id:string, request: Brand) =>
    put<{ id: string }>(`${brandBaseUrl}/brands/${id}`, request);

  return useMutationWithErrorHandling({
    mutationFn: async ({ id, request }: { id: string; request: Brand }) =>
      await updateBrand(id, request),
  });
}